import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Box, Stack } from '@mui/material';
import { browserTime, displayDuration } from '../../utils/parsing';
import { HeartbeatsLoader } from '../loaders/deployments';

const Entry = ({ now, latestHeartbeat: hb, lastContact, heartbeats }) => {
  const contact = lastContact && displayDuration(now - lastContact, 'millis');
  const uptime = hb && displayDuration(hb.uptime_seconds, 'seconds');
  const dayInMinutes = 1 * 24 * 60;
  const ago24 = new Date().getTime() - dayInMinutes * 60 * 1000;
  const heartbeatCount = heartbeats?.filter((h) => h.timestamp > ago24)?.length ?? 0;
  return (
    <Box
      component="span"
      style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      {contact != null ? (
        <Tooltip tag="contact" title={`Last contact @ ${browserTime(lastContact)}`}>
          Last contact: {contact.val} {contact.unit} ago
        </Tooltip>
      ) : null}
      {hb != null ? (
        <>
          <div>
            Uptime: {uptime.val} {uptime.unit}
          </div>
          <div>
            Heartbeats Received (24h): {heartbeatCount} / {dayInMinutes / 5}
          </div>
        </>
      ) : (
        <div>No recent heartbeats</div>
      )}
    </Box>
  );
};

const DeploymentMonitor = ({ deployment, latestHeartbeat, heartbeats, now }) => (
  <Stack direction="row">
    <HeartbeatsLoader site={deployment.site} />
    <Entry
      now={now}
      latestHeartbeat={latestHeartbeat}
      heartbeats={heartbeats}
      lastContact={deployment.last_heartbeat}
    />
  </Stack>
);

function mapStateToProps(state, { deployment }) {
  const {
    entities: {
      deployments: { latestHeartbeats, heartbeats },
    },
  } = state;
  const latestHeartbeat = latestHeartbeats[deployment.site];
  return {
    latestHeartbeat,
    heartbeats: heartbeats[deployment.site],
  };
}

// eslint-disable-next-line no-unused-vars
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(DeploymentMonitor);
